import { Controller } from "@hotwired/stimulus"

// Drives the single shared "Manage Access" modal on the Fabric workspaces index.
// Each row's Access button opens this one modal (native Bootstrap) and carries the
// workspace's access URL. On show we point the turbo-frame at that URL, so only the
// opened workspace's access manager — and its Turbo stream subscription — is loaded.
// On hide we restore the placeholder, tearing the subscription down.
export default class extends Controller {
  static targets = ["frame", "title"]

  connect() {
    this.placeholder = this.frameTarget.innerHTML
    this.element.addEventListener("show.bs.modal", this.load)
    this.element.addEventListener("hidden.bs.modal", this.reset)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.load)
    this.element.removeEventListener("hidden.bs.modal", this.reset)
  }

  load = (event) => {
    const button = event.relatedTarget
    if (!button) return

    if (this.hasTitleTarget && button.dataset.workspaceName) {
      this.titleTarget.textContent = `Manage Access — ${button.dataset.workspaceName}`
    }
    this.frameTarget.src = button.dataset.accessUrl
  }

  reset = () => {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = this.placeholder
    if (this.hasTitleTarget) this.titleTarget.textContent = "Manage Access"
  }
}
